module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/editorial_div-26d1481980f8409ce68d3c5b0ceba34d.webp";